"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.AnnouncementButton = void 0;
var _ImportedContentFragment = _interopRequireDefault(require("./../ContentFragments/ImportedContentFragment"));
var _reactRouterDom = require("react-router-dom");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styles = require("@mui/material/styles");
var _classnames = _interopRequireDefault(require("classnames"));
var _object = require("./../../utils/type-checks/object");
var _string = require("./../../utils/type-checks/string");
var _uuid = require("uuid");
var _material = require("@mui/material");
var _react = _interopRequireWildcard(require("react"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const merge = require("deepmerge"),
  AnnouncementButton = props => {
    const {
        customClassNames,
        theme,
        ...rest
      } = props,
      styles = {
        color: "#000000",
        borderColor: "#000000"
      },
      buttonClasses = (0, _classnames.default)({
        "Announcement__button": true,
        [`${customClassNames}`]: (0, _string.isStringOfLength)(customClassNames)
      }),
      ButtonFragment = props => {
        const {
          customClassNames,
          path,
          label,
          onClick,
          testId,
          url,
          variant = "outline"
        } = props;
        return /*#__PURE__*/_react.default.createElement(_react.Fragment, null, (0, _string.isStringOfLength)(label) && (0, _string.isStringOfLength)(path) && /*#__PURE__*/_react.default.createElement(_material.Button, {
          className: customClassNames,
          component: _reactRouterDom.Link,
          "data-testid": testId,
          onClick: onClick,
          sx: styles,
          to: path,
          variant: variant
        }, label), (0, _string.isStringOfLength)(label) && (0, _string.isStringOfLength)(url) && !(0, _string.isStringOfLength)(path) && /*#__PURE__*/_react.default.createElement(_material.Button, {
          className: customClassNames,
          component: "a",
          "data-testid": testId,
          onClick: onClick,
          href: url,
          sx: styles,
          target: "_blank",
          variant: variant
        }, label));
      };
    return /*#__PURE__*/_react.default.createElement(_react.Fragment, null, (0, _object.isObject)(theme) && /*#__PURE__*/_react.default.createElement(_styles.ThemeProvider, {
      theme: theme
    }, /*#__PURE__*/_react.default.createElement(ButtonFragment, _extends({
      customClassNames: buttonClasses
    }, rest))), !(0, _object.isObject)(theme) && /*#__PURE__*/_react.default.createElement(ButtonFragment, _extends({
      customClassNames: buttonClasses
    }, rest)));
  };

/**
 * Page Announcement Component, use as a child of the main content container
 *
 * @visibleName Announcement
 * @author [Jeff Stevens](mailto:jeffrey.stevens@pheaa.org)
*/
exports.AnnouncementButton = AnnouncementButton;
const Announcement = props => {
  const {
      buttonArray = [],
      children,
      customClassNames,
      customTheme = {},
      fragmentId,
      header,
      headerTag = "h2",
      icon = {
        alt: "Announcement Message",
        src: `${process.env.PUBLIC_URL}/general/images/icons/icon--alert.svg`,
        height: "8rem",
        width: "auto"
      },
      id,
      initialTheme = {},
      styles = {},
      testId
    } = props,
    theme = merge.all([initialTheme, (0, _styles.useTheme)(), customTheme]),
    defaultStyles = {
      alignItems: "center",
      backgroundColor: "#FFF7E5",
      borderRadius: `${theme.shape.borderRadius}px`,
      boxShadow: "0 2px 4px rgba(0, 0, 0, 0.25)",
      color: "#454545",
      display: "flex",
      flexDirection: {
        xs: "column",
        md: "row"
      },
      "li": {
        textAlign: "left"
      },
      fontFamily: theme.fontFamilies.default,
      fontSize: theme.font_size,
      justifyContent: "flex-start",
      lineHeight: "1.4",
      margin: {
        xs: `${theme.contentSpacing.mobileInterior} 0`,
        md: `${theme.contentSpacing.desktopInterior} 0`
      },
      padding: {
        xs: "2.5rem",
        md: "3.6rem"
      },
      width: "100%",
      "h1,h2,h3,h4,h5,h6,.Announcement__header": {
        fontFamily: theme.fontFamilies.semiBold,
        fontSize: {
          xs: "2.6rem",
          md: "3rem"
        },
        letterSpacing: "5px",
        lineHeight: "1em",
        margin: "0 0 2.5rem 0",
        padding: "0",
        textAlign: {
          xs: "center",
          md: "left"
        },
        textTransform: "uppercase"
      },
      ".Announcement__icon": {
        marginTop: "0",
        alignSelf: {
          xs: "center",
          md: "flex-start"
        },
        flexBasis: icon.width,
        flexGrow: "0",
        flexShrink: "0",
        height: icon.height,
        marginBottom: {
          xs: "2rem",
          md: "0"
        },
        marginRight: {
          xs: "0",
          md: "3.8rem"
        },
        width: icon.width
      },
      ".Announcement__actions": {
        flexBasis: "auto",
        flexGrow: "0",
        flexShrink: "0",
        marginLeft: {
          xs: "0",
          md: "3.8rem"
        },
        textAlign: {
          xs: "center",
          md: "left"
        },
        whiteSpace: "nowrap"
      },
      ".Announcement__content": {
        flexBasis: "auto",
        flexGrow: "1",
        flexShrink: "1",
        textAlign: {
          xs: "center",
          md: "left"
        },
        padding: {
          xs: "1.6rem 0 0",
          md: "0 1.6rem"
        },
        whiteSpace: "normal",
        "*:last-child": {
          marginBottom: "0"
        }
      },
      ".MuiCardContent-root:last-child": {
        paddingBottom: "0 !important"
      }
    },
    componentStyles = merge(defaultStyles, styles),
    announcementClasses = (0, _classnames.default)({
      "Announcement": true,
      [`${customClassNames}`]: (0, _string.isStringOfLength)(customClassNames)
    }),
    idSeed = (0, _react.useRef)((0, _uuid.v4)());
  return /*#__PURE__*/_react.default.createElement(_material.Card, {
    component: "div",
    "data-testid": testId,
    id: id,
    className: announcementClasses,
    sx: componentStyles
  }, /*#__PURE__*/_react.default.createElement(_material.CardMedia, {
    alt: icon.alt,
    className: "Announcement__icon",
    component: "img",
    src: icon.src,
    sx: {
      marginTop: "1.2rem"
    }
  }), /*#__PURE__*/_react.default.createElement(_material.CardContent, {
    className: "Announcement__content"
  }, header && /*#__PURE__*/_react.default.createElement(_material.Typography, {
    className: "Announcement__header",
    component: headerTag
  }, header), fragmentId && /*#__PURE__*/_react.default.createElement(_ImportedContentFragment.default, {
    id: fragmentId
  }), children), buttonArray.length > 0 && /*#__PURE__*/_react.default.createElement(_material.CardActions, {
    className: "Announcement__actions"
  }, buttonArray.map((buttonData, i) => /*#__PURE__*/_react.default.createElement(AnnouncementButton, _extends({
    key: `Announcement__button_${idSeed.current}--${i}`
  }, buttonData, {
    theme: (0, _object.isObject)(initialTheme) && Object.keys(initialTheme).length > 0 ? theme : undefined
  })))));
};

// Define propTypes;
Announcement.propTypes = {
  /** One or more objects describing buttons (Default Value: []) */
  buttonArray: _propTypes.default.arrayOf(_propTypes.default.shape({
    /** Button Label */
    label: _propTypes.default.any.isRequired,
    /** Button Path, if an internal React Route */
    path: _propTypes.default.string,
    /** External URL, if an outside link */
    url: _propTypes.default.string,
    /** Button variant */
    variant: _propTypes.default.string
  })),
  /** Child nodes, inserts after header and fragment content */
  children: _propTypes.default.any,
  /** Custom class(es) */
  customClassNames: _propTypes.default.string,
  /** Theme injection property (Default Value: {}) */
  customTheme: _propTypes.default.object,
  /** Header Text */
  header: _propTypes.default.string,
  /** Header component tag (Default Value: "h2") */
  headerTag: _propTypes.default.oneOf(["h1", "h2", "h3", "h4", "h5", "h6"]),
  /** Fragment ID, inserts after header */
  fragmentId: _propTypes.default.string,
  /** Icon image properties */
  icon: _propTypes.default.shape({
    /** Alternative Text (Default Value: "Announcement Message") */
    alt: _propTypes.default.string.isRequired,
    /** Image path (Default Value: "/general/images/icons/icon--alert.svg") */
    src: _propTypes.default.string.isRequired,
    /** Image height (Default Value: "8rem") */
    height: _propTypes.default.string,
    /** Image width (Default Value: "auto") */
    width: _propTypes.default.string
  }),
  /** DOM ID of announcement */
  id: _propTypes.default.string,
  /** Theme stub from Custom Element */
  initialTheme: _propTypes.default.object,
  /** Any custom override styles (Default Value: {}) */
  styles: _propTypes.default.object,
  /** @ignore */
  testId: _propTypes.default.string
};
AnnouncementButton.propTypes = {
  customClassNames: _propTypes.default.string,
  label: _propTypes.default.string,
  onClick: _propTypes.default.func,
  path: _propTypes.default.string,
  testId: _propTypes.default.string,
  variant: _propTypes.default.string,
  theme: _propTypes.default.object,
  url: _propTypes.default.string
};

// Export component as default;
var _default = exports.default = Announcement;